import React from "react";
import { ConditionedAttribute } from "./HelpersConditional";

interface ConditionalContextType {
  conditions: ConditionedAttribute[] | undefined;
  selectedCondition: number | undefined;
  updateValues: (newValue: any, conditionIndex: number) => void;
  changeSelectedCondition: (newValue: number) => void;
  unconditionedName: string;
  addConditionalResult: (addKey?: string, addValue?: object) => void;
}

export const ConditionalContext = React.createContext<ConditionalContextType>({
  conditions: undefined,
  selectedCondition: undefined,
  updateValues: (value, index) => undefined,
  changeSelectedCondition: (value) => undefined,
  unconditionedName: "",
  addConditionalResult: (addKey, addValue) => undefined,
});

export const useConditionalContext = () => React.useContext(ConditionalContext);
